<template>
    <div class="page-links">
        <div class="tabs" flex="">
            <div class="item" :class="{active: current == 0}" @click="current = 0">系统页面</div>
            <div class="item" :class="{active: current == 1}" @click="current = 1">气模商品详情</div>
            <div class="item" :class="{active: current == 2}" @click="current = 2">授权商品详情</div>
        </div>
        <div class="lists" flex="" v-if="current == 0">
            <div class="item" :class="{active: currentLink == c.link}" v-for="(c,i) in pages" :key="i" @click="toSelectLink(c)">{{c.name}}</div>
        </div>
        <div class="select-item" v-if="current == 1">
            <div class="title">请选择您要绑定的气模商品：<el-button @click="selectItemDialog = true">选择气模商品</el-button></div>
            <div class="link" v-if="currentLink">已绑定链接：{{currentLink}}</div>
        </div>
        <div class="select-item" v-if="current == 2">
            <div class="title">请选择您要绑定的授权商品：<el-button @click="selectScopeItemDialog = true">选择授权商品</el-button></div>
            <div class="link" v-if="currentLink">已绑定链接：{{currentLink}}</div>
        </div>
        <!-- <div class="select-item" v-if="current == 2">
            <div class="title">请选择您要绑定的自定义页面：<el-button @click="selectPageDialog = true">选择页面</el-button></div>
            <div class="link" v-if="currentLink">已绑定链接：{{currentLink}}</div>
        </div> -->

        <div class="btn">
            <el-button type="primary" @click="sureSubmit">确认提交</el-button>
        </div>

		<el-dialog title="选择气模商品" :visible.sync="selectItemDialog" append-to-body width="80%">
            <SelectItem v-if="selectItemDialog" @success="selectSuccess"></SelectItem>
		</el-dialog>

		<el-dialog title="选择授权商品" :visible.sync="selectScopeItemDialog" append-to-body width="80%">
            <SelectScopeItem v-if="selectScopeItemDialog" @success="selectScopeSuccess"></SelectScopeItem>
		</el-dialog>

		<el-dialog title="选择页面" :visible.sync="selectPageDialog" append-to-body width="80%">
            <SelectPage :shopDesignTemplateId="shopDesignTemplateId" v-if="selectPageDialog" @success="selectPageSuccess"></SelectPage>
		</el-dialog>
    </div>
</template>

<script>
import SelectItem from './SelectItem.vue'
import SelectScopeItem from './SelectScopeItem.vue'
// import SelectPage from '../views/shopDesign/PageList.vue'
export default {
    props: {
        shopDesignTemplateId: {
            type: Number,
            default: 0,
        }
    },
    data(){
        return {
            selectScopeItemDialog: false,
            selectPageDialog: false,
            selectItemDialog: false,
            current: 0,
            pages: [
                {name: '首页', link: '/pages/index/index'},
                {name: '分类页', link: '/pages/item/index'},
                {name: '授权商品页', link: '/pages/scope/index'},
                {name: '购物车', link: '/pages/item/cart'},
                {name: '个人中心', link: '/pages/user/index'},
                {name: '我的订单', link: '/pages/user/orders'},
                {name: '我的收藏', link: '/pages/user/collect'},
                {name: '收货地址', link: '/pages/user/address'},
                {name: '升级VIP', link: '/pages/user/vip'},
                {name: '分享领券', link: '/pages/user/recommend'},
            ],
            currentLink: '',
        }
    },
    components: {
        SelectItem,
        SelectScopeItem,
        // SelectPage
    },
    methods: {
        toSelectLink(row){
            this.currentLink = row.link
        },
        selectSuccess(item){
            this.selectItemDialog = false;
            this.currentLink = '/pages/item/detail?id=' + item.id;
        },
        selectScopeSuccess(item){
            this.selectScopeItemDialog = false;
            this.currentLink = '/pages/scope/detail?id=' + item.id;
        },
        selectPageSuccess(row){
            this.selectPageDialog = false;
            this.currentLink = '/pages/index/custom_page?id=' + row.id;
        },
        sureSubmit(){
            if(!this.currentLink){
                return this.$message({
                    message: '请选择链接',
                    type: 'error'
                })
            }
            this.$emit("success", this.currentLink)
        }
    }
}
</script>

<style lang="scss" scoped>
    .tabs{
        border-bottom: 1px solid #ccc;
        .item{
            margin-right: 30px;
            height: 40px;
            line-height: 40px;
            cursor: pointer;
            &.active{
                font-weight: bold;
                color: #ff3300;
                border-bottom: 1px solid #ff3300;
            }
        }
    }
    .lists{
        padding: 30px 0;
        flex-wrap: wrap;
        .item{
            width: 120px;
            height: 30px;
            text-align: center;
            line-height: 30px;
            border: 1px solid #ccc;
            margin-right: 20px;
            margin-bottom: 20px;
            cursor: pointer;
            &.active{
                background: #ff3300;
                color: #fff;
                border-color: #ff3300;
            }
        }
    }
    .select-item{
        padding: 30px 0;
        .link{
            padding-top: 20px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/PageLink.vue